import * as React from "react";
import { Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = (theme) => ({
  sectionCaption: {
    marginBottom: 10,
    fontSize: 20,
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      fontSize: 10,
    },
    lineHeight: 1.4,
  },
});

const SectionCaption = (props) => {
  const { classes, ...rest } = props;
  return (
    <Typography variant={"body2"} className={classes.sectionCaption} {...rest}>
      {props.children}
    </Typography>
  );
};

export default withStyles(styles)(SectionCaption);



// WEBPACK FOOTER //
// ./src/components/UI/SectionCaption.jsx